import { render } from "./SetsDeadline.vue?vue&type=template&id=7935ad54"
import script from "./SetsDeadline.vue?vue&type=script&lang=js"
export * from "./SetsDeadline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__